import { faPen, faTrash, faQuestionCircle, faUserCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../Auth/AuthContext'
import { Table, Button,Row,Col,Form } from 'react-bootstrap';
import { useHistory } from 'react-router-dom'
import { LanguageContext } from '../Language/LanguageContext';
import { TablePagination, Loading } from '../Library';
import { AlertModalContext } from '../Library/AlertModalContext'
import { ModalContext } from '../Library/ModalContext';
import { ImagePreview } from '../Library'
import { NotifyContext } from '../Library/Notify'
import "./UserLinkroom.css"
import axios from 'axios'
import DatePicker from "react-datepicker";
import { Height } from '@material-ui/icons';

function Rooms(props) {
    const alertModal = useContext(AlertModalContext)
    const langCx = useContext(LanguageContext)
    const notifyCx = useContext(NotifyContext);
    const lang = langCx.lang.linkroom
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false)
    const [visitorReportList, setVisitorReportList] = useState([])
    const [companyName, setCompanyName] = useState("")
    const [page, setPage] = useState(1)
    const size = 10
    const [count, setCount] = useState(0)
    const [securityVisitor, setSecurityVisitor] = useState([])
    const [roomsList, setRoomsList] = useState([])
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null) 
    const modal = useContext(ModalContext)

    useEffect(() => {
        const fetchUserList = async () => {
            if (!props.token) return;
    
            try {
                setIsLoading(true)
                console.log('Token : ', props.token)
                const headers = {
                    'Authorization': props.token,
                };
                const roomsListData = await axios.post(
                    'https://visitor-api.lifelink.co.th:10443/linkroom/api/v1/admin_listroom',
                    null,
                    { headers }
                );
                console.log(roomsListData.data.data.flat())
                setRoomsList(Array.isArray(roomsListData.data.data) ? roomsListData.data.data.flat() : []);
                setIsLoading(false)
            } catch (e) {
                console.error(e);
                setIsLoading(false)
            }
        };
    
        fetchUserList();
    }, [props.token]);
        

    const formattedDate = (date) => {
        const dateFormatted = dayjs(date).format("D MMM YYYY - H:mm")
        return dateFormatted
    }

    const showRooms =  (img)  =>{
        const images = `data:image/jpeg;base64,${img}`;
        console.log(images)
        modal.setComponent(
            <div style={{justifySelf:'center'}}>
                <img 
                        src={images} 
                        alt="Base64 Preview" 
                        style={{ maxwidth: '100%', height:'auto'}}
                    />
            </div>
        )
        modal.setHeader(lang.attach_image)
        modal.setDark(false)
        modal.setShow(true)
    }

    const RoomsListItems = ({ img64,roomname,room_id,capacity, imglink }) => {
        return(
            <tr>
                <td></td>
                <td>{
                    <img 
                        src={`data:image/jpeg;base64,${img64}`} 
                        alt="Base64 Preview" 
                        style={{ width: '160px' }}
                        onClick={()=>showRooms(img64)}
                    />}
                </td>
                <td style={{ alignContent:'center'}}>{roomname}</td>
                <td style={{ alignContent:'center'}}>{capacity}</td>
                <td>
                    {/*
                    <div className="action-container">
                        <Button size="sm"
                        onClick={onEditClick}>
                            <FontAwesomeIcon icon={faPen}/>
                        </Button>
                        <Button size="sm" variant="danger" style={{marginLeft: 10}}
                        onClick={onDeleteClick}>
                            <FontAwesomeIcon icon={faTrash}/>
                        </Button> 
                    </div>
        */}
                </td>
            </tr>
        )
    }

    return(
        <div id="visitor-report">
            { isLoading ? <Loading/> : null }
            <div className="button-container">
                <div style={{display:'flex', justifyContent:'space-between'}}>
                    <div>{lang.linkroomrooms}</div>
                </div>
            </div>
            {/*
            <div>
            
            <Row>
                <Col md={6} lg={6}>
                            <Form.Group>
                                <Form.Label>{'วันที่เริ่มต้น'}</Form.Label>
                                <div>
                                <DatePicker 
                                selected={startDate}
                                onChange={(date)=>{
                                    setStartDate(date)
                                }}
                                className="form-control" 
                                dateFormat="d MMMM yyyy"
                                placeholderText={'วันที่เริ่มต้น'}
                                maxDate={new Date()}
                                />
                                </div>
                            </Form.Group>
                </Col>
                <Col md={6} lg={6}>
                            <Form.Group>
                                <Form.Label>{'วันที่สิ้นสุด'}</Form.Label>
                                <div>
                                <DatePicker 
                                selected={endDate}
                                onChange={(date)=>{
                                    setEndDate(date)
                                }}
                                className="form-control" 
                                dateFormat="d MMMM yyyy"
                                placeholderText={'วันที่สิ้นสุด'}
                                maxDate={new Date()}
                                minDate={startDate}
                                />
                                </div>
                            </Form.Group>
                </Col>
            </Row>
            </div>
            */}
            
            <div className='table-container'>
                <Table hover>
                    <thead>
                        <tr>
                            <th></th>
                            <th>{lang.imgrooms}</th>
                            <th>{lang.roomname}</th>
                            <th>{lang.capacity}</th>
                        </tr>
                    </thead>
                    <tbody>
                        
                        { roomsList.map((item, key) =>
                        <RoomsListItems
                        key={key}
                        img64={item.img_64}
                        roomname={item.roomname}
                        roomid={item.room_id}
                        capacity={item.capacity}
                        imglink={item.img}
                        //onEditClick={()=>history.push("/visitor_security/edit/"+item.security_id)}
                        //onDeleteClick={()=>deleteSecureFromList(item.security_id, item.security_name)}
                        />
                        )}
                    </tbody>
                </Table>
            </div>
        </div>
    )
}

export default Rooms;
